import BackendService from 'BackendService';
import Document from '../models/Document';
import FundOpportunity from '../models/FundOpportunity';

export const downloadDoc = async (doc: Document) => {
  const backend = new BackendService();
  try {
    const url = await backend.getAssetByURL(doc.location, { url: true });

    // Try to extract extension from the path
    const match = doc.location.match(/\.(\w+)(\?.*)?$/);
    const extension = match ? `.${match[1]}` : '';

    const filename = doc.title.replace(/[^a-z0-9_-]+/gi, '_').concat(extension);

    const link = document.createElement('a');
    link.href = url as string;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error('Failed to download file', err);
  }
};

export const downloadPublishedPDF = (fundOpportunity: FundOpportunity) => {
  new BackendService()
    .getStaticPDF('FundOpportunity', fundOpportunity.linkedContentExternalId || fundOpportunity.id)
    .then((url: string | null) => {
      if (!url) {
        return;
      }
      const title = (fundOpportunity.summaryTitle || fundOpportunity.name || 'opportunity')
        .replace(/[<>:"/\\|?*\x00-\x1F]/g, '') // Remove invalid filename characters
        .slice(0, 255); // Truncate to max filename length if necessary

      const a = document.createElement('a');
      a.href = url;
      a.download = `${title}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    })
    .catch((error: any) => {
      console.error('Error downloading PDF:', error);
    });
};
